import React, { useCallback, useState } from 'react'
import block from 'bem-cn'

import { ICryptoCurrencyWithMinAndMaxItem } from 'services/api/PaymentApi/types/types'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { LocalePaymentType } from 'shared/locale/en-US'
import { AvailableCryptoCurrenciesList } from 'shared/models/Crypto'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ChoosePayment } from '../ChoosePayment'
import { CryptoPayment } from '../CryptoPayment'

import './DepositPayments.scss'

interface IPaymentDetails {
  changeSystem: (system: '') => void
  cryptoList: ICryptoCurrencyWithMinAndMaxItem[]
  locale: LocalePaymentType
  initialValue?: string
  type?: string
}

const b = block('deposit-payments')

export const NowPayments: React.FC<IPaymentDetails> = ({ cryptoList, locale, changeSystem, initialValue, type }) => {
  const { replaceLastModal } = useModalContext()
  const [selectedCrypto, setSelectedCrypto] = useState(initialValue || '')

  // const [isAgreed, setIsAgreed] = useState(false)
  // const localePayment = useSelector(selectLocaleDict, shallowEqual).payment

  const onChangeCryptoSystem = useCallback((value: string) => {
    setSelectedCrypto(value)
  }, [])

  const onClickBackHandler = useCallback(() => {
    if (type && selectedCrypto) {
      setSelectedCrypto('')
    } else if (type && !selectedCrypto) {
      changeSystem('')
      replaceLastModal(MODAL_ROUTE_URLS.DEPOSIT())()
    } else if (!type && selectedCrypto) {
      setSelectedCrypto('')
    } else {
      changeSystem('')
    }
  }, [changeSystem, replaceLastModal, selectedCrypto, type])

  // useEffect(() => {
  //   setIsAgreed(false)
  // }, [selectedCrypto])

  return (
    <div className={b()}>
      <div>
        {selectedCrypto ? (
          <CryptoPayment
            isAgreed
            selectedCrypto={selectedCrypto as AvailableCryptoCurrenciesList}
            onGoBack={onClickBackHandler}
          />
        ) : (
          <ChoosePayment
            systemList={[]}
            cryptoList={cryptoList}
            changeSystem={onChangeCryptoSystem}
            onGoBack={onClickBackHandler}
            locale={locale}
            isLoading={false}
            isCrypto
          />
        )}

        {/* <div className={b('buttons-wrapper')}>
          <div className={b('button-wrapper')}>
            <Button text={locale.back} callback={() => onClickBackHandler()} uppercase bordered={false} />
          </div>
          {!isAgreed && selectedCrypto && (
            <div className={b('button-wrapper')}>
              <Button
                callback={() => setIsAgreed(true)}
                text={localePayment.continue}
                variant="main"
                uppercase
                bordered={false}
              />
            </div>
          )}
        </div> */}
      </div>
    </div>
  )
}
